import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRouteMatch, useHistory } from "react-router-dom";
import {
  IonGrid,
  IonRow,
  IonLabel,
  IonSkeletonText,
  IonText,
  IonButton,
  IonInput,
  IonIcon,
  IonModal,
} from "@ionic/react";
import { createOutline } from "ionicons/icons";
import "Styles/Global/ProjectDetails.scss";
import "Styles/Global/Modal.scss";
import HorizontalScrollThumbnailGallery from "Components/Global/HorizontalScrollThumbnailGallery";
import { edit_consultation_name } from "Store/project/thinks";

// Keep the phone settings route available while hiding its project-page entry point.
const SHOW_PHONE_SETTINGS_BUTTON = false;

const ProjectDetails = ({ project_data, hide_title, consultation_data }) => {
  const [modalVisibility, setModalVisibility] = useState(false);
  const [consultationName, setConsultationName] = useState("");

  const dispatch = useDispatch();
  const match = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    if (consultation_data) {
      setConsultationName(consultation_data.name);
    }
  }, [consultation_data]);

  if (project_data === undefined) {
    return <IonSkeletonText animated />;
  }

  const { name, description, project_images } = project_data;

  const edit_consultation_name_handler = (name) =>
    dispatch(
      edit_consultation_name({
        history,
        project_objectId: match.params.project_objectId,
        consultation_objectId: consultation_data.objectId,
        consultation_name: name,
      })
    );

  const open_edit_consultation_modal = () => {
    setConsultationName(consultation_data?.name || "");
    setModalVisibility(true);
  };

  const close_edit_consultation_modal = () => {
    setModalVisibility(false);
    setConsultationName(consultation_data?.name || "");
  };

  return (
    <>
      <IonModal
        isOpen={modalVisibility}
        cssClass="consultation-name-modal"
        onDidDismiss={close_edit_consultation_modal}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const nextConsultationName = consultationName.trim();

            if (!nextConsultationName) {
              return;
            }

            close_edit_consultation_modal();
            edit_consultation_name_handler(nextConsultationName);
          }}
          className="consultation-name-modal__form"
        >
          <IonLabel className="consultation-name-modal__title">
            Edit consultation name
          </IonLabel>
          <IonInput
            className="consultation-name-modal__input"
            placeholder="Enter consultation name"
            type="text"
            onIonChange={(e) => setConsultationName(e.detail.value || "")}
            value={consultationName}
            required
          />
          <div className="consultation-name-modal__actions">
            <IonButton type="submit">Save</IonButton>
            <IonButton type="button" onClick={close_edit_consultation_modal}>
              Cancel
            </IonButton>
          </div>
        </form>
      </IonModal>

      <IonGrid className="project-details">
        {hide_title !== true && (
          <IonRow className="top">
            <h1 className="name">{name}</h1>
            {SHOW_PHONE_SETTINGS_BUTTON && (
              <IonButton
                className="questionnaire"
                size="small"
                fill="outline"
                color="dark"
                routerLink={`/questionnaire/${project_data.objectId}`}
              >
                Settings &rarr;
              </IonButton>
            )}
          </IonRow>
        )}
        {consultation_data ? (
          <IonRow
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <IonButton
              style={{ marginRight: 10 }}
              class="edit-button"
              onClick={open_edit_consultation_modal}
            >
              <IonIcon color="light" size="large" icon={createOutline} />
            </IonButton>
            <h1>{consultation_data.name}</h1>
          </IonRow>
        ) : null}
        <IonRow>
          <IonText>
            <p className="description">{description}</p>
          </IonText>
        </IonRow>
        {project_images?.length > 0 && (
          <>
            <HorizontalScrollThumbnailGallery images={project_images} />
          </>
        )}
      </IonGrid>
    </>
  );
};

export default ProjectDetails;
